import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';
import { UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';

interface IObjectInfoProps {
  title: string;
  address: string;
  isDesktop: boolean;
  statusLabel?: React.ReactNode;
  estimationBanner?: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export function ObjectInfo({
  title,
  address,
  statusLabel,
  estimationBanner,
  isDesktop,
  ref,
}: IObjectInfoProps): React.JSX.Element {
  return (
    <div
      ref={ref}
      data-testid="ObjectInfoId"
      className={cn(styles['container'], { [styles['widthout-estim']]: estimationBanner })}
    >
      {statusLabel}
      <div className={styles['title']}>
        <UIHeading4 data-testid="ObjectInfoTextId">{title}</UIHeading4>
      </div>
      {isDesktop ? (
        <UIText2 color="text-secondary-default">{address}</UIText2>
      ) : (
        <UIText1 color="text-secondary-default">{address}</UIText1>
      )}
      {estimationBanner}
    </div>
  );
}
